import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import PageHeading from '@RHEnvironmental/pattern-library/dist/js/components/PageHeading';
import PageSection from '@RHEnvironmental/pattern-library/dist/js/components/PageSection';
import LoadingIndicator from '@RHEnvironmental/pattern-library/dist/js/components/LoadingIndicator';

import Button from '@RHEnvironmental/pattern-library/dist/js/components/Button';
import MainLayout from '../../modules/MainLayout';
import MainContent from '../../modules/MainContent';
import Card from '../../modules/Card';
import SignUpByInviteForm from '../../forms/SignUpByInvite';
import BodyText from '../../modules/BodyText';

import * as accountActions from '../../../actions/account';
import { SIGN_IN } from '../../../constants/routeDestinations';
import {RenderIf} from "../../modules/RenderIf/RenderIf";
import {Alert} from "../../modules/Alert/Alert";
import {localise} from "../../../services/lang/lang";

const SignUp = ({
    match: {
        params: { token },
    },
    invite,
    getInviteByToken,
    setSignedUpUser,
    emailExists,
    isLoadingInvite,
    reset,
    signedUpUser,
    inviteInvalid,
}) => {
    useEffect(() => {
        getInviteByToken(token);

        return () => {
            reset();
        };
    }, [getInviteByToken, reset, token]);

    const onExistingAccountSignUpSuccess = () => {
        window.location = SIGN_IN;
    };

    return (
        <MainLayout>
            <RenderIf condition={inviteInvalid}>
              <Alert status="error" title={localise('INVALID_INVITE_TITLE')} icon>
                {localise('INVALID_INVITE_BLURB')}
              </Alert>
            </RenderIf>
            <MainContent>
                {!isLoadingInvite && !inviteInvalid ? (
                    <PageSection className="page-section--standalone">
                        {signedUpUser ? (
                            <>
                                <PageHeading level={3} className="mb-4">
                                    Account confirmation
                                </PageHeading>
                                <Card>
                                    <BodyText>
                                        Thanks for joining,{' '}
                                        {signedUpUser.first_name}.
                                    </BodyText>
                                    {!emailExists ? (
                                        <BodyText>
                                            Please check your email to confirm
                                            your account and access your team
                                            dashboard and app.
                                        </BodyText>
                                    ) : (
                                        <>
                                            <BodyText>
                                                Continue to get access the team
                                                dashboard, or download the app
                                                start creating an inspection.
                                            </BodyText>
                                            <Button
                                                onClick={
                                                    onExistingAccountSignUpSuccess
                                                }
                                            >
                                                Continue
                                            </Button>
                                        </>
                                    )}
                                </Card>
                            </>
                        ) : (
                            <>
                                <PageHeading level={3} className="mb-4">
                                    Sign Up
                                </PageHeading>
                                <Card>
                                    <BodyText>
                                        Join {invite.service_provider.name}'s
                                        team.{' '}
                                        {emailExists &&
                                            'You can use your existing RHE Global account to sign in.'}
                                    </BodyText>
                                    <SignUpByInviteForm
                                        emailExists={emailExists}
                                        onSuccess={setSignedUpUser}
                                        token={token}
                                        invite={invite}
                                    />
                                </Card>
                            </>
                        )}
                    </PageSection>
                ) : (
                    <RenderIf condition={isLoadingInvite}>
                     <LoadingIndicator dicator show />
                    </RenderIf>
                )}
            </MainContent>
        </MainLayout>
    );
};

const mapStateToProps = (state) => ({
    ...state.pages.account,
});

const mapDispatchToProps = (dispatch) => ({
    getInviteByToken(token) {
        dispatch(accountActions.getInviteByToken(token));
    },
    setSignedUpUser(user) {
        dispatch(accountActions.signedUpUserRefreshed(user));
    },
    reset() {
        dispatch(accountActions.reset());
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(SignUp);
